import React, { useState, useEffect } from "react";

import InvoiceBalance from "./InvoiceBalance";
import PaymentHistory from "./PaymentHistory";
import Statement from "./Statement";
import RefundHistory from "./RefundHistory";
import { useLocation } from "react-router-dom";

import { PageSubTitle } from "../../StyledComponents";
import { Div } from "../Styles";
import {
  // Container,
  // TabPanel,
  // Tabs,
  // New Styles
  NewContainer,
  NewTabPanel,
  NewTabs,
} from "./styles";
import SuperBill from "./superBill/index";

const Group = () => {
  const location = useLocation();
  const [opt, setOpt] = useState(1);
  const [invoOpt, setInvOpt] = useState(true);
  const [payOpt, setPayOpt] = useState(false);
  const [statementOpt, setStatementOpt] = useState(false);
  const [superBill, setSuperBill] = useState(false);
  const [refundOpt, setRefundOpt] = useState(false);

  const handleTabs = (e) => {
    setOpt(e);
    setInvOpt(e === 1);
    setPayOpt(e === 2);
    setStatementOpt(e === 3);
    setSuperBill(e === 4);
    setRefundOpt(e === 5);
  };
  useEffect(() => {
    if (location.state?.tab) {
      handleTabs(location.state.tab);
    }
  }, [location.state]);

  return (
    <>
      <NewContainer>
        <PageSubTitle padding="0px 0px 16px 0px">
          {opt === 1
            ? "Pending Invoices"
            : opt === 2
              ? "Payment History"
              : opt === 3
                ? "Statement"
                : opt === 4
                  ? "Superbill"
                  : "Refund History"}
        </PageSubTitle>
        <NewTabPanel>
          <NewTabs active={opt === 1} onClick={() => handleTabs(1)}>
            Pending Invoices
          </NewTabs>
          <NewTabs
            active={opt === 2}
            onClick={() => handleTabs(2)}
            id="bil_invLs-pyHis"
          >
            Payment History
          </NewTabs>
          <NewTabs active={opt === 3} onClick={() => handleTabs(3)}>
            Statement
          </NewTabs>
          <NewTabs active={opt === 4} onClick={() => handleTabs(4)}>
            Superbill
          </NewTabs>
          <NewTabs active={opt === 5} onClick={() => handleTabs(5)}>
            Refund History
          </NewTabs>
        </NewTabPanel>
        <Div marginTop="6px">
          {opt === 1 ? (
            <InvoiceBalance />
          ) : opt === 2 ? (
            <PaymentHistory />
          ) : opt === 3 ? (
            <Statement />
          ) : opt === 4 ? (
            <SuperBill />
          ) : (
            <RefundHistory />
          )}
        </Div>
      </NewContainer>

      {/* Old UI Commented Out
      <Container>
        <PageSubTitle padding="20px">
          {opt === 1
            ? "Invoice List"
            : opt === 2
            ? "Payment History"
            : "Statement"}
        </PageSubTitle>
        <TabPanel>
          <Tabs active={invoOpt} onClick={() => handleTabs(1)}>
            Invoice Balance
          </Tabs>
          <Tabs
            active={payOpt}
            onClick={() => handleTabs(2)}
            id="bil_invLs-pyHis"
          >
            Payment History
          </Tabs>
          <Tabs active={statementOpt} onClick={() => handleTabs(3)}>
            Statement
          </Tabs>
          <Tabs active={superBill} onClick={() => handleTabs(4)}>
            Superbill
          </Tabs>
        </TabPanel>
        <Div marginTop="25px">
          {opt === 1 ? (
            <InvoiceBalance />
          ) : opt === 2 ? (
            <PaymentHistory />
          ) : opt === 3 ? (
            <Statement />
          ) : (
            <SuperBill />
          )}
        </Div>
      </Container>
      */}
    </>
  );
};

export default Group;
